<script lang="ts" setup>
import { useField } from 'vee-validate';
import { computed, toRef } from 'vue';

import { useInteractionMode } from '@/kasten-components/composables';

import type { ControlProps, KaVeeFormGroupProps } from './types';
export type { ControlProps, KaVeeFormGroupProps } from './types';

const props = withDefaults(defineProps<KaVeeFormGroupProps>(), {
  mode: 'passive-aggressive',
  keepValueOnUnmount: true,
  value: true,
  uncheckedValue: false,
});
defineSlots<{
  default: (props: ControlProps) => void;
}>();

const isCheckboxOrRadio = computed(() => props.radio || props.checkbox);

const fieldInfo = useField(() => props.name, toRef(props, 'rules'), {
  validateOnMount: props.validateOnMount,
  bails: props.bails,
  keepValueOnUnmount: props.keepValueOnUnmount,
  validateOnValueUpdate: false,
  standalone: props.standalone,
  type: (() => {
    if (props.radio) return 'radio';
    if (props.checkbox) return 'checkbox';

    return undefined;
  })(),
  checkedValue: isCheckboxOrRadio.value ? props.value : undefined,
  uncheckedValue: isCheckboxOrRadio.value ? props.uncheckedValue : undefined,
});

const { errorMessage, value: formValue, checked, checkedValue, setTouched } = fieldInfo;

const interactionModeHandlers = useInteractionMode<any>(() => props.mode, fieldInfo);
const onTouch = () => setTouched(true);

defineExpose(fieldInfo);
</script>
<template>
  <slot
    v-bind="{
      ...interactionModeHandlers,
      errorMessage,
      onTouch,
      modelValue: isCheckboxOrRadio ? (checked ?? false) : formValue,
      name: props.name,
      ...(isCheckboxOrRadio && 'value' in props ? { value: checkedValue } : {}),
    }"
  />
</template>
